/** 默认全局配置 */
let config={
    "pipeModel": { // 管道模型
        "size": { // 尺寸
            "innerDiameter": 0, // 管道内径
            "pipeThick": 0, // 管道壁厚
            "pipeLength": 0, // 管道长度
        },
        "layingMode": "overhead", // 敷设方式
        "environParam": { // 环境参数
            id:1,
            "airTempe": 20, // 空气温度
            "airVelocity": 3.5 // 空气流速
        },
        "soilParam": { // 土壤参数
            id:1,
            "soilQuality": " 粗沙 ", // 土质
            "soilMoistSat": 0.3, // 土壤含水饱和率
            "soilPorosity": 0, // 土壤孔隙率
            "soilTempe": 10, // 土壤温度
            "soilThermConduct": 1.2, //土壤导热系数
            "buriedDepth":1.4 // 埋设深度                
        },
        "pipeParam":{
            id:1,
            "pipeMaterial": "20#钢管", // 管道材质
            "absRough": 0.0546, // 绝对粗糙度
            "pipeThermConduct": 38.65, // 管道导热系数
            "blackness": 0.23, // 黑度
        } // 管道参数
    },
    // 保温设置
    "insulaSet": { 
        id:1,
        name:"默认方案",
        // 保温层数
        insulaNumber:1,
        // 保温方案
        insulaScheme:[
            {
                id:1,
                name: '第一层保温',
                // 保温厚度
                insulaThick: 0.0, 
                // 保温材料
                insulaMaterial:{
                    id:1,
                    name:"默认材料",
                    λ0:0,
                    Tmax:0,
                    A1:0,
                    A0:0,
                    B1:0,
                    B0:0,
                    C1:0,
                    C0:0
                } 
            },
        ], 
    },

    // 管道温压测点设置
    tempePressRangeSet:{
        id:1,
        name:"默认方案",
        upperPressLimit:2, // 压力上限
        upperTempeLimit:1000, // 温度上限
    },

    /**
     * 表格字段配置
     */
    fieldSet:{
        // 节点
        branch:{
            simutype:["water","insulationWater"], // 显示介质，如果为空，则表示所有介质都显示
            title:"节点", // 类型的名称，主要就是为了显示表格面板的名字
            name:"branch",// 当前节点的名称，为了在遍历的时候使用
            _type:"branch", // 图形类型，就是地图上的图形的类型，如果是管道的化，就是line,其他的节点就是Node的_type
            fields:{
                elevation:{
                    name:"elevation",
                    title:"标高",
                    default:0,
                    type:"Number",
                }, // 标高
                demand:{
                    name:"demand",
                    title:"需水量",
                    default:0,
                    type:"Number",
                },// 需水量
            },
        },
        // 水管道
        waterLine:{
            simutype:["water"],// 显示介质
            title:"水管道", // 中文字段
            name:"waterLine",// 类型名称
            _type:"line", // 图形类型
            fields:{
                length:{
                    name:"length",
                    title:"管道长度",
                    default:100,
                    type:"Number",
                }, // 管道长度
                diameter:{
                    name:"diameter",
                    title:"管道内径",
                    default:100,
                    type:"Number",
                },// 管道内径
                roughness:{
                    name:"roughness",
                    title:"粗糙度",
                    default:1,
                    type:"Number",
                }, // 粗糙度
                minorloss:{
                    name:"minorloss",
                    title:"损失系数",
                    default:0.0,
                    type:"Number",
                }, // 损失系数
                initialdatas:{
                    name:"initialdatas",
                    title:"初始状态",
                    default:0.0,
                    type:"Select",
                }, // 初始状态
                localResCoeff:{
                    name:"localResCoeff",
                    title:"局部阻力系数",
                    default:0.0,
                    type:"Number",
                }, // 局部阻力系数
            },
        },
        // 水管道
        insulationWater:{
            simutype:["insulationWater"],// 显示介质
            title:"保温水管道", // 中文字段
            name:"insulationWater",// 类型名称
            _type:"line", // 图形类型
            fields:{
                length:{
                    name:"length",
                    title:"管道长度",
                    default:100,
                    type:"Number",
                }, // 管道长度
                diameter:{
                    name:"diameter",
                    title:"管道内径",
                    default:100,
                    type:"Number",
                },// 管道内径
                roughness:{
                    name:"roughness",
                    title:"粗糙度",
                    default:1,
                    type:"Number",
                }, // 粗糙度
                minorloss:{
                    name:"minorloss",
                    title:"损失系数",
                    default:0.0,
                    type:"Number",
                }, // 损失系数
                initialdatas:{
                    name:"initialdatas",
                    title:"初始状态",
                    default:0.0,
                    type:"Select",
                }, // 初始状态
                localResCoeff:{
                    name:"localResCoeff",
                    title:"局部阻力系数",
                    default:0.0,
                    type:"Number",
                }, // 局部阻力系数
                "pipeThick":{
                    name:"pipeThick",
                    title:"壁厚",
                    default:0.0,
                    type:"Number",
                },// 壁厚
                "layerMethod":{
                    name:"layerMethod",
                    title:"铺设方式",
                    default:"地埋",
                    type:"String",
                },// 铺设方式
                "insulaSchemeId":{
                    name:"insulaSchemeId",
                    title:"保温方案ID",
                    default:0,
                    type:"Number",
                }, // 保温方案
            },
        },
        // 水池
        tank:{
            simutype:["water","insulationWater"],
            title:"水池",
            name:"tank",
            _type:"tank", // 图形类型
            fields:{
                elevation:{
                    name:"elevation",
                    title:"标高",
                    default:0,
                    type:"Number",
                }, // 标高
                initlevel:{
                    name:"initlevel",
                    title:"初始水位",
                    default:10,
                    type:"Number",
                },// 初始水位
                minlevel:{
                    name:"minlevel",
                    title:"最低水位",
                    default:0,
                    type:"Number",
                }, // 最低水位
                maxlevel:{
                    name:"maxlevel",
                    title:"最高水位",
                    default:20,
                    type:"Number",
                }, // 最高水位
                diameter:{
                    name:"diameter",
                    title:"直径",
                    default:50,
                    type:"Number",
                }, // 直径
                minvol:{
                    name:"minvol",
                    title:"最小容积",
                    default:0.0,
                    type:"Number",
                }, // 最小容积
            },
        },
        // 水库
        reservoir:{
            simutype:["water","insulationWater"],
            title:"水库",
            name:"reservoir",
            _type:"reservoir", // 图形类型
            fields:{
                elevation:{
                    name:"elevation",
                    title:"标高",
                    default:0,
                    type:"Number",
                }, // 标高
            }
        },
        // 阀门
        valve:{
            simutype:["water","insulationWater"],
            title:"阀门",
            name:"valve",
            _type:"valve", // 图形类型
            fields:{
                diameter:{
                    name:"diameter",
                    title:"阀门内径",
                    default:12,
                    type:"Number",
                }, // 阀门内径
                type:{
                    name:"type",
                    title:"类型",
                    default:"PRV",
                    type:"String",
                }, // 类型
                setting:{
                    name:"setting",
                    title:"粗糙度",
                    default:0,
                    type:"Number",
                }, // 粗糙度
                minorloss:{
                    name:"minorloss",
                    title:"损失系数",
                    default:0,
                    type:"Number",
                }, // 损失系数
            }
        },
        // 普通节点
        common:{
            simutype:"",
            title:"其他节点",
            name:"common",
            _type:"common", // 图形类型
            fields:{
                name:{
                    name:"name",
                    title:"图形类型",
                    default:'节点',
                    type:"String",
                }
            },
        },

        // 蒸汽官网
        steamLine:{
            simutype:"steam",
            title:"蒸汽管网",
            name:"steamLine",
            _type:"line", // 图形类型
            fields:{
                "innerDiameter": {
                    name:"innerDiameter",
                    title:"管道内径",
                    default:0,
                    type:"Number",
                }, // 管道内径
                "pipeThick": {
                    name:"pipeThick",
                    title:"管道壁厚",
                    default:0,
                    type:"Number",
                }, // 管道壁厚
                "pipeLength":{
                    name:"pipeLength",
                    title:"管道长度",
                    default:0,
                    type:"Number",
                }, // 管道长度
                "layingMode":{
                    name:"layingMode",
                    title:"敷设方式",
                    default:"overhead",
                    type:"String",
                }, // 敷设方式
                "airTempe":{
                    name:"airTempe",
                    title:"空气温度",
                    default:20,
                    type:"Number",
                }, // 空气温度
                "airVelocity":{
                    name:"airVelocity",
                    title:"空气温度",
                    default:3.5,
                    type:"Number",
                }, // 空气流速
                "soilQuality":{
                    name:"soilQuality",
                    title:"土质",
                    default:"粗沙",
                    type:"String",
                }, // 土质
                "soilMoistSat":{
                    name:"soilMoistSat",
                    title:"土壤含水饱和率",
                    default:0.3,
                    type:"Number",
                }, // 土壤含水饱和率
                "soilPorosity":{
                    name:"soilPorosity",
                    title:"土壤孔隙率",
                    default:0,
                    type:"Number",
                }, // 土壤孔隙率
                "soilTempe":{
                    name:"soilTempe",
                    title:"土壤温度",
                    default:10,
                    type:"Number",
                }, // 土壤温度
                "soilThermConduct":{
                    name:"soilThermConduct",
                    title:"土壤导热系数",
                    default:1.2,
                    type:"Number",
                }, //土壤导热系数
                "buriedDepth":{
                    name:"buriedDepth",
                    title:"埋设深度",
                    default:1.4,
                    type:"Number",
                }, // 埋设深度  
                "pipeMaterial":{
                    name:"pipeMaterial",
                    title:"管道材质",
                    default:"20#钢管",
                    type:"String",
                }, // 管道材质
                "absRough":{
                    name:"absRough",
                    title:"绝对粗糙度",
                    default:0.0546,
                    type:"Number",
                }, // 绝对粗糙度
                "pipeThermConduct":{
                    name:"pipeThermConduct",
                    title:"管道导热系数",
                    default:38.65,
                    type:"Number",
                }, // 管道导热系数
                "blackness":{
                    name:"blackness",
                    title:"黑度",
                    default:0.23,
                    type:"Number",
                }, // 黑度            
            }
        }

    },

    // 保温材料列表
    insulaMaterialSugs:[        
        {           
            id:1,            
            name:"硅酸铝",     
            λ0:0.055,        
            Tmax:500,            
            A1:0.0002,            
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0      
        },
        {           
            id:2,            
            name:"膨胀珍珠岩",       
            λ0:0.065,        
            Tmax:500,            
            A1:0.00012,            
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:3,            
            name:"硅酸铝棉",       
            λ0:0.055,        
            Tmax:500,            
            A1:0.0002,          
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:4,            
            name:"硅酸钙",       
            λ0:0.062,        
            Tmax:500,            
            A1:0.00011,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:5,            
            name:"复合硅酸盐涂料",       
            λ0:0.065,        
            Tmax:500,            
            A1:0.00017,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:6,            
            name:"复合硅酸盐管/毡",      
            λ0:0.05,        
            Tmax:500,            
            A1:0.00015,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:7,            
            name:"岩棉/矿渣棉",      
            λ0:0.044,        
            Tmax:500,            
            A1:0.00018,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:8,            
            name:"岩棉/矿渣棉毡",       
            λ0:0.049,      
            Tmax:500,            
            A1:0.00018,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:9,            
            name:"岩棉/矿渣棉板",      
            λ0:0.044,
            Tmax:500,            
            A1:0.00018,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:10,            
            name:"岩棉/矿渣棉管",       
            λ0:0.044,       
            Tmax:500,            
            A1:0.00018,        
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0       
        },
        {           
            id:11,            
            name:"高温玻璃棉",    
            λ0:0.042,        
            Tmax:500,            
            A1:0.00017,            
            A0:70,            
            B1:0,            
            B0:0,           
            C1:0,           
            C0:0,
            unitPrice:0      
        },
    ],
    // 保温方案列表
    insulaSchemeSugs:[
        {
            id:1,
            name:"默认方案",
            insulaNumber:1, // 保温层数
            insulaScheme:[
                {
                    id:1,
                    name: '第一层保温',
                    insulaThick: 0.0, // 保温厚度
                    insulaMaterialId:0, // 保温材料ID
                    insulaMaterial:{
                        id:1,
                        name:"默认材料",
                        /**
                         * 省略了其他的保温材料的内容
                         */
                        
                    } // 保温材料
                },
            ], // 保温方案
        }
    ], 
    // 架空方案列表
    overHeadParamSugs:[
        {
            id:1,
            name:"默认方案",
            airTempe:20, // 空气温度
            airVelocity:3, // 空气湿度
        }
    ],
    // 地埋参数方案列表
    buriedParamSugs:[
        {
            id:1,
            name:"默认方案",
            soilQuality:"粗沙", // 土质选择
            soilMoistSat:0.3, // 土壤含水饱和率
            soilPorosity:0, // 土壤孔隙率
            soilTempe:10, // 土壤温度
            soilThermConduct:1.2, // 土壤导热系数   
            buriedDepth:1.4 // 埋设深度                             
        } 
    ],
    // 管道参数方案列表
    pipeParamSugs:[
        {
            id:1,
            name:"默认方案",
            pipeMaterial: "20#钢管", // 管道材质
            absRough:0.0546, // 绝对粗糙度
            blackness:0.23, // 黑度
            pipeThermConduct:38.65, // 管道导热系数
        } 
    ],
    // 管道温压测点方案列表
    tempePressRangeSugs:[
        {
            id:1,
            name:"默认方案",
            upperPressLimit:2, // 压力上限
            upperTempeLimit:1000, // 温度上限
        },
        {
            id:1,
            name:"默认方案1",   
            upperPressLimit:3, // 压力上限
            upperTempeLimit:1500, // 温度上限
        }
    ]

}

export const globalConfig=config;

/**
 * 获取属性的默认值，转换成键值对的形式
 * {
 *   key1:value1,
 *   key2:value2
 * }
 */
 export const getDefault=(type)=>{
    let res={};
    let configType=config.fieldSet[type];
    if(!type||!configType){
        return res;
    }
    let fields=configType.fields;
    for(let field in fields){
        res[field]=fields[field].default;
    }
    return res;
}